import { ResultadoValidacion } from "../Contenedores/ResultadoValidacion";
import { apiValideIngresoUsuario } from "../Utils/constantes";
import { trackPromise } from "react-promise-tracker";
import Http from "./Http";

export async function ValideIngresoUsuario(identificacion: string) {
  const salida = new ResultadoValidacion();
  const url = apiValideIngresoUsuario.replace(
    "{identificacion}",
    identificacion
  );

  const respuesta = await trackPromise(Http.get(url));
  salida.Errores = respuesta.data.errores;
  salida.EsValido = respuesta.data.esValido;

  return salida;
}

export default {
  ValideIngresoUsuario,
};
